import { StoreMismatchError } from "@packages/store/types";

export const ensure = <T>(
  argument: T | undefined | null,
  message = "This value was promised to be there."
): T => {
  if (argument === undefined || argument === null) {
    throw new StoreMismatchError(message);
  }

  return argument;
};
